import {Breadcrumbs, ErrorPopup, Title} from '@management-ui/core';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      {children}
      <ErrorPopup errors={['type']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Categories', link: routes.auditTypes.index}
];

export default Wrapper;
